import { defineMessages } from 'react-intl';

export const scope = 'app.components.Importer';

// No sport terms in this copy, so a plain export rather than a termLookup factory.
export const importerMessages = defineMessages({
  noticeRequiredRemaining: {
    id: `${scope}.noticeRequiredRemaining`,
    defaultMessage: 'The following fields require a confirmed column mapping:'
  },
  noticeOptionalRemaining: {
    id: `${scope}.noticeOptionalRemaining`,
    defaultMessage: '100% of required columns are matched. Some optional columns still remain. Do you want to continue?'
  },
  noticeAllFieldsMatched: {
    id: `${scope}.noticeAllFieldsMatched`,
    defaultMessage: '100% of fields are matched. Do you want to confirm all mappings?'
  },
  noticeAllConfirmed: {
    id: `${scope}.noticeAllConfirmed`,
    defaultMessage: 'All columns are mapped and confirmed. Do you want to continue?'
  },
  noticeOverflowColumns: {
    id: `${scope}.noticeOverflowColumns`,
    defaultMessage: 'Some rows contain more values than your header row has columns. {columnNoun} {columns} cannot be mapped, so those values will not be imported. Affected {rowNoun}: {rows}.'
  },
  btnContinue: {
    id: `${scope}.btnContinue`,
    defaultMessage: 'Continue'
  },
  dlgUnconfirmedTitle: {
    id: `${scope}.dlgUnconfirmedTitle`,
    defaultMessage: 'Unconfirmed column mappings'
  },
  dlgUnconfirmedMessage: {
    id: `${scope}.dlgUnconfirmedMessage`,
    defaultMessage: '{count} matched {columnNoun} {hasHave} not been confirmed — {columns}. Confirm {itThem} to include that data in the import, or discard {itThem} to leave it out.'
  },
  btnConfirmAllContinue: {
    id: `${scope}.btnConfirmAllContinue`,
    defaultMessage: 'Confirm All & Continue'
  },
  btnDiscardContinue: {
    id: `${scope}.btnDiscardContinue`,
    defaultMessage: 'Discard & Continue'
  },
  btnKeepEditing: {
    id: `${scope}.btnKeepEditing`,
    defaultMessage: 'Keep Editing'
  }
});
